import CampaignsTable from "./CampaignsTable"

export default CampaignsTable
